'use client';

import { usePublicContent } from '@/lib/use-public-content';

export default function LegalContent({ initialHtml }: { initialHtml: string }) {
    const { html } = usePublicContent('privacy-policy', { html: initialHtml });

    return (
        <div
            className="legal-content h-full w-full container mx-auto max-lg:px-4 px-0 pb-20 pt-10 text-white"
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}
